import { getAttachmentManager } from "@/firebase/AttachmentManager";
import Attachment from "../Filesystem/Attachment";
import UploadStrategy from "./UploadStategy";
import * as Filesystem from "@/firebase/Filesystem";
import * as Snackbars from "@/utils/Snackbars";

export default class FirebaseUploadStrategy extends UploadStrategy {
  constructor(file: File, path: string, useFileName: boolean) {
    super(file, path);
    this.useFileName = useFileName;
  }
  public useFileName: boolean;

  public override async prepare(): Promise<void> {}
  public override generateAttachment(): Attachment | null {
    return new Attachment(
      this.getFileName()!,
      getAttachmentManager().resolveType(this.file),
      this.path + (this.useFileName ? "/" + this.file.name : ""),
      null,
      null
    );
  }
  public override getFileName(): string | null {
    if (this.useFileName) {
      return this.file.name;
    } else {
      var split = this.path.split("/");
      return split[split.length - 1];
    }
  }
  public override upload(done: Function): void {
    var fileReader = new FileReader();

    var instance = this;

    var snackbar = Snackbars.uploader(this);

    fileReader.addEventListener("load", async function (evt: any) {
      let result = await Filesystem.uploadFile(
        instance.path,
        instance.file,
        evt.target.result,
        (value: number) => {
          instance.progress.value = value;
        },
        instance.useFileName
      );

      done(instance.file, result);

      Snackbars.remove(snackbar.el.parentNode);
    });

    fileReader.readAsArrayBuffer(this.file);
  }
}
